import React from 'react';

/*
 * This screen was scaffolded using only design-system.md as context, see the
 * "Built for agentic workflows" section of the case study for the exact prompt.
 * It draws on the Masked Card Display (§3.4) and Trust / Permission Panel (§3.13)
 * specs only.
 */

const CARDS: { issuer: string; type: string; last4: string; sync: 'synced' | 'syncing' | 'needs-reauth' }[] = [
  { issuer: 'Amex', type: 'Platinum', last4: '4821', sync: 'synced' },
  { issuer: 'Chase', type: 'Sapphire', last4: '1190', sync: 'syncing' },
  { issuer: 'Citi', type: 'Double Cash', last4: '7734', sync: 'needs-reauth' },
];

const SYNC_META: Record<string, { label: string; varName: string }> = {
  synced: { label: 'Synced', varName: 'var(--color-fresh)' },
  syncing: { label: 'Syncing…', varName: 'var(--color-syncing)' },
  'needs-reauth': { label: 'Needs reauth', varName: 'var(--color-aging)' },
};

const PERMISSIONS = [
  { label: 'Transaction categories', detail: 'Used to rank offers by what you actually spend on.' },
  { label: 'Merchant names', detail: 'Used to match Quick Check searches to your linked cards.' },
  { label: 'Card issuer & type', detail: 'Never your full card number, only issuer and card type are stored.' },
];

const AgentDemoSettingsScreen: React.FC = () => (
  <div className="cache__agentscreen">
    <div className="cache__agentscreen-header">Data &amp; security</div>

    <div className="cache__agentscreen-group-title">Linked cards</div>
    <div className="cache__agentscreen-cards">
      {CARDS.map(c => (
        <div className="cache__agentscreen-card" key={c.last4}>
          <span className="cache__agentscreen-card-issuer">{c.issuer} {c.type}</span>
          <span className="cache__agentscreen-card-last4">•••• {c.last4}</span>
          <span className="cache__agentscreen-card-sync">
            <span className="cache__agentscreen-dot" style={{ background: SYNC_META[c.sync].varName }} aria-hidden="true" />
            {SYNC_META[c.sync].label}
          </span>
        </div>
      ))}
    </div>

    <div className="cache__agentscreen-group-title">What's used, and why</div>
    <div className="cache__agentscreen-permissions">
      {PERMISSIONS.map(p => (
        <div className="cache__agentscreen-permission" key={p.label}>
          <span className="cache__agentscreen-permission-label">{p.label}</span>
          <span className="cache__agentscreen-permission-detail">{p.detail}</span>
        </div>
      ))}
    </div>

    <button type="button" className="cache__agentscreen-button">Manage permissions</button>
  </div>
);

export default AgentDemoSettingsScreen;
